import { render, staticRenderFns } from "./AddFaqCategoryComponent.vue?vue&type=template&id=753c056c&"
import script from "./AddFaqCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./AddFaqCategoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports